import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    textAlign: 'center',
    backgroundColor: '#0F1010',

    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  text: {
    color: theme.palette.grey[400],

    '& span': {
      color: theme.palette.common.white,
    },
  },
  timer: {
    marginTop: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(0),
      marginLeft: theme.spacing(8),
    },
  },
  timerItem: {
    display: 'inline-block',
    width: 62,
    padding: theme.spacing(1),
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey[800],
    borderRadius: 8,

    '& h6': {
      lineHeight: 1,
    },

    '&:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
}));
